export const PreferenciasIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="4" y="4" width="40" height="40" rx="20" fill="#D1FADF" />
    <path
      d="M16.5 17V32H31.5V26.375H22.125V17H16.5ZM17.75 18.25H20.875V19.5H19V20.75H20.875V22H19V23.25H20.875V24.5H19V25.75H20.875V26.7461L17.75 29.8711V18.25ZM21.7539 27.625H22.75V29.5H24V27.625H25.25V29.5H26.5V27.625H27.75V29.5H29V27.625H30.25V30.75H18.6289L21.7539 27.625Z"
      fill="#333333"
    />
    <rect
      x="4"
      y="4"
      width="40"
      height="40"
      rx="20"
      stroke="#ECFDF3"
      strokeWidth="8"
    />
  </svg>
);
